<template>
  <div class="span">
    <div class="typing_loader"></div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.typing_loader {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  -webkit-animation: typing 1s linear infinite alternate;
  -moz-animation: Typing 1s linear infinite alternate;
  animation: typing 1s linear infinite alternate;
  margin: calc(45vh - 76px) auto; /* Not necessary- its only for layouting*/
  position: relative;
  left: -70px;
}
@-webkit-keyframes typing {
  0% {
    background-color: #ffd8b4;
    box-shadow: 20px 0px 0px 0px #f77e0b, 24px 0px 0px 0px #f77e0b;
  }
  25% {
    background-color: #ffa755;
    box-shadow: 20px 0px 0px 0px #ffa754, 24px 0px 0px 0px #f77e0b;
  }
  75% {
    background-color: #ffa755;
    box-shadow: 20px 0px 0px 0px #f77e0b, 24px 0px 0px 0px #ffd8b4;
  }
}

@-moz-keyframes typing {
  0% {
    background-color: #ffc894;
    box-shadow: 20px 0px 0px 0px #f77e0b, 24px 0px 0px 0px #f77e0b;
  }
  25% {
    background-color: #ffa755;
    box-shadow: 20px 0px 0px 0px #ffa754, 24px 0px 0px 0px #f77e0b;
  }
  75% {
    background-color: #ffa755;
    box-shadow: 20px 0px 0px 0px #f77e0b 24px 0px 0px 0px #ffd8b4;
  }
}

@keyframes typing {
  0% {
    background-color: #ffd8b4;
    box-shadow: 48px 0px 0px 0px #f77e0b, 24px 0px 0px 0px #f77e0b;
  }
  25% {
    background-color: #ffa755;
    box-shadow: 48px 0px 0px 0px #ffa754, 24px 0px 0px 0px #f77e0b;
  }
  75% {
    background-color: #ffa755;
    box-shadow: 48px 0px 0px 0px #f77e0b, 24px 0px 0px 0px #ffd8b4;
  }
}
</style>
